export default function () {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            insertSentenceFrame: '=insertSentenceFrame'
        },
        /* eslint-disable no-param-reassign */
        link: (scope) => {
            scope.determineListClass = (index, isLast) => {
                if (index === 0) {
                    return 'divider mdc-list-item';
                } if (isLast) {
                    return 'mdc-list-item';
                }
                return 'divider mdc-list-item search-result';
            };

        },
        template: `<ul class="mdc-list mdc-list--textual-list" id="mdc-list">
                <li ng-class="determineListClass($index, $last)" ng-repeat="item in data track by $index"
                    ng-click="insertSentenceFrame(item)">
                    <span class="mdc-list-item__ripple"></span>
                    <span class="mdc-list-item__text">{{ item.text }}</span>
                </li>
            </ul>`
    };
};